module.exports = __webpack_public_path__ + "static/logos/sf_logo--white-d4ed3cefe6a856f383a204ae831da28b.svg";